import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import {
  getAllEmployeeAttendenceNotResignedOfDate,
  createAttendence,
} from "../../../actions/AttendenceAction";
import {
  getAllEmployeeByBranchAttendanceP,
  getAllEmployeeByBranchShiftAttendanceP,
} from "../../../actions/employeeAction";
import Rendertable from "./Rendertable";
import moment from "moment";
import { Pagination, Spin } from "antd";

const EmployeeAttendanceList = ({
  getAllEmployeeAttendenceNotResignedOfDate,
  createAttendence,
  employeeAttendancelist,
  getAllEmployeeByBranchAttendanceP,
  getAllEmployeeByBranchShiftAttendanceP,
  employeeList,
  date,
  shift,
  branch,
  updatelist,
  setUpdatelist,
  loading,
  setData,
}) => {
  const dateFormat = "YYYY-MM-DD";
  let attendanceDate = moment(date, dateFormat);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  const employeeData = [];
  const totalCount = employeeList && employeeList.count ? employeeList.count : 0;
  const paginatedResults = employeeList && employeeList.data ? employeeList.data : [];

  useEffect(() => {
    if (!attendanceDate.isValid()) {
      attendanceDate = moment(new Date(), dateFormat);
    }

    getAllEmployeeAttendenceNotResignedOfDate(attendanceDate, shift, branch, currentPage, pageSize).then(
      () => {
        getAllEmployeeByBranchShiftAttendanceP(branch, shift, currentPage, pageSize).then(() => {
          setUpdatelist(true);
        });
      }
    );
  }, [currentPage, updatelist, date, shift, branch, setUpdatelist]);

  // Filter non-resigned employees from the current page
  paginatedResults
    .filter((emp) => emp.is_resigned === false)
    .forEach((employee) => {
      employeeData.push({ ...employee });
    });

  employeeData.forEach((employee) => {
    employeeAttendancelist.forEach((attendance) => {
      let req_format = attendanceDate.format("YYYY-MM-DD");
      if (
        employee["id"] === attendance["employeeId"] &&
        attendance["attendanceDate"] === req_format &&
        attendance["shift"] === shift
      ) {
        employee["attendanceDate"] = attendance["attendanceDate"];
        employee["isAttended"] = attendance["isAttended"];
        employee["entryTime"] = attendance["entryTime"];
        employee["exitTime"] = attendance["exitTime"];
        employee["note"] = attendance["note"];
        employee["overTime"] = attendance["overTime"];
        employee["lateTime"] = attendance["lateTime"];
        employee["shift"] = attendance["shift"];
      }
    });
  });

  employeeData.forEach((employee) => {
    if (employee["attendanceDate"] === undefined) employee["attendanceDate"] = date;
    if (employee["shift"] === undefined) employee["shift"] = shift;
    if (employee["isAttended"] === undefined) employee["isAttended"] = false;
    if (employee["entryTime"] === undefined) employee["entryTime"] = employee["defaultEntryTime"];
    if (employee["exitTime"] === undefined) employee["exitTime"] = employee["defaultExitTime"];
    if (!employee["note"]) employee["note"] = "";
    if (!employee["overTime"]) employee["overTime"] = 0.0;
    if (!employee["lateTime"]) employee["lateTime"] = 0.0;
  });

  useEffect(() => {
    setData(employeeData);
    loading.current = false;
  }, [employeeData, setData]);

  const onPageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <>
      <Rendertable
        List={employeeAttendancelist}
        employees={employeeData}
        create={createAttendence}
        date={attendanceDate}
        shift={shift}
        updatelist={updatelist}
        setUpdatelist={setUpdatelist}
        loading={loading}
      />
      <div style={{ textAlign: "center", marginTop: 16 }}>
        <Pagination
          current={currentPage}
          pageSize={pageSize}
          total={totalCount}
          onChange={onPageChange}
          showSizeChanger={false}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  employeeAttendancelist:
    Array.isArray(state.employeeAttendance.employeeAttendancelist)
      ? state.employeeAttendance.employeeAttendancelist
      : state.employeeAttendance.employeeAttendancelist.data || [],
  employeeList: state.employee.employeelistByBranchShift,
});

export default connect(mapStateToProps, {
  getAllEmployeeAttendenceNotResignedOfDate,
  createAttendence,
  getAllEmployeeByBranchAttendanceP,
  getAllEmployeeByBranchShiftAttendanceP,
})(EmployeeAttendanceList);
